import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../lib/utils';
import EmergencyStatusPropType from '../../prop-types/emergency-status';

import SocialShareModal from '../SocialShareModal';

const OutageSocialShare = ({ url, status, includeDiesel: sellsDiesel, onComplete }) => {
  const link = url || window.location.href;
  const hasPower = !status.has_power || (status.has_power && status.has_power.report_status);
  const hasGas = !status.has_gas || (status.has_gas && status.has_gas.report_status);
  const hasDiesel = !status.has_diesel || (status.has_diesel && status.has_diesel.report_status);
  let message;

  // If gas, diesel, and power - GasBuddy reports this station as being fully operational.
  // If gas and power, no diesel- GasBuddy reports this station as having gas, but no diesel.
  // If diesel and power, no gas - GasBuddy reports this station as having diesel, but no gas.
  // If power, no gas and no diesel - GasBuddy reports this station as having power, but no fuel.
  // If out of everything, or no power- GasBuddy reports this station as being out-of-service.
  if (hasPower && hasGas && ((sellsDiesel && hasDiesel) || !sellsDiesel)) {
    message = 'GasBuddy reports this station as being fully operational.';
  } else if (hasPower && hasGas && sellsDiesel && !hasDiesel) {
    message = 'GasBuddy reports this station as having gas, but no diesel.';
  } else if (hasPower && !hasGas && sellsDiesel && hasDiesel) {
    message = 'GasBuddy reports this station as having diesel, but no gas.';
  } else if (hasPower && !hasGas && (!sellsDiesel || (sellsDiesel && !hasDiesel))) {
    message = 'GasBuddy reports this station as having power, but no fuel.';
  } else if (!hasPower) {
    message = 'GasBuddy reports this station as being out-of-service.';
  } else {
    throw new Error('Invalid Station Status');
  }

  return (
    <SocialShareModal
      title="Share Station Status"
      message="Let family and friends know about the status of this station."
      emailParams={{
        subject: message,
        body: `${message}\n\n${link}`,
      }}
      facebookParams={{
        u: link,
        quote: message,
      }}
      twitterParams={{
        url: link,
        text: message,
      }}
      onShare={onComplete}
    />
  );
};

OutageSocialShare.propTypes = {
  url: PropTypes.string,
  status: EmergencyStatusPropType,
  includeDiesel: PropTypes.bool,
  onComplete: PropTypes.func,
};

OutageSocialShare.defaultProps = {
  url: undefined,
  status: {},
  includeDiesel: false,
  onComplete: noop,
};

export default OutageSocialShare;
